module.exports = __webpack_public_path__ + "img/movimagen.45a12810.png";